import tinymce from 'tinymce';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/wordcount';
import 'tinymce/models/dom';

const initTinyMce = () => {
    const maxChars = 300;

    tinymce.init({
        selector: '.js-tinymce',
        plugins: ['link', 'lists'],
        toolbar:
            'bold italic link bullist',
        menubar: false,
        skin: false,
        license_key: 'gpl',
        setup: (editor) => {
            const element = editor.getElement();
            const counter = element.nextElementSibling;

            const getTextLength = (html) => {
                const div = document.createElement('div');
                div.innerHTML = html;
                return div.textContent.length;
            };

            const trimHTMLToChars = (html, maxChars) => {
                const div = document.createElement('div');
                div.innerHTML = html;
                let textLength = 0;

                const traverse = (node) => {
                    if (textLength >= maxChars) {
                        node.remove();
                        return;
                    }

                    if (node.nodeType === Node.TEXT_NODE) {
                        if (textLength + node.textContent.length > maxChars) {
                            node.textContent = node.textContent.slice(0, maxChars - textLength);
                        }
                        textLength += node.textContent.length;
                        } else if (node.nodeType === Node.ELEMENT_NODE) {
                        [...node.childNodes].forEach(traverse);
                    }
                };

                [...div.childNodes].forEach(traverse);
                return div.innerHTML;
            };

            editor.on('input', () => {
                let content = editor.getContent();
                let charCount = getTextLength(content);

                if (charCount > maxChars) {
                    const trimmed = trimHTMLToChars(content, maxChars);

                    // Preserve cursor position
                    const bookmark = editor.selection.getBookmark(2, true);
                    editor.setContent(trimmed);
                    editor.selection.moveToBookmark(bookmark);

                    charCount = maxChars;
                }

                counter.textContent = `${charCount} / ${maxChars} characters`;
            });
        }
    });
};

export default initTinyMce;
